import moment from 'moment'

export default {
  getAds (VueApp, params, callback) {
    VueApp.$sdk.get(VueApp, '/ads/brand/' + params.brandId + '/web', {}, res => {
      if (!res.error) {
        let startDate = moment(res.startDate, 'YYYY-MM-DD@HH:mm')
        let endDate = moment(res.endDate, 'YYYY-MM-DD@HH:mm')
        let today = moment()

        if (today.isBetween(startDate, endDate, null, '[]') &&
          params.brandId === VueApp.$store.state.brandId
        ) {
          VueApp.$store.commit('ads/setList', [res])
        }
      } else {
        // console.log('Ads ERROR:', res.error)
      }
      callback(res)
    })
  }
}



// WEBPACK FOOTER //
// ./src/modules/api/ads.js